import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DepartmentForm } from '@/components/forms/DepartmentForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function DepartmentCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/division-management/departments')
  }

  const handleCancel = () => {
    navigate('/division-management/departments')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex={1}>
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create Department</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new department to the catalog
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex={1} minH={0}>
              <DepartmentForm onSuccess={handleSuccess} onCancel={handleCancel} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
